import React from 'react';
import { RegistrationAttributions } from './LineItemTypes';



interface IndividualRegistrationFormProps
{
    loggedInUser: string
    componentName: string,
    regData: RegistrationAttributions,
    isUserTargetEnabled: boolean,
    disableInputs: boolean,
    defaultOption: RadioButtonOptions
    onDataChange: (index: number, data: any, isValid: boolean, errorMsg?: string) => void
}

export enum RadioButtonOptions {
    loggedInUser = 'loggedInUser',
    custom = 'custom'
}

//Since TS doesn't support reverse mapping, and radio button input converts to string...
//TODO: Optimize This so it doesn't have to be added to when new options are added.
export const radioButtonOptionsReverseMap = (value: string) =>
{
    if(value == 'loggedInUser')
    {
        return RadioButtonOptions.loggedInUser;
    }
    return RadioButtonOptions.custom;
}

const IndividualRegistrationForm = (props: IndividualRegistrationFormProps) =>
{
    const [selectedOption, setSelectedOption] = React.useState<RadioButtonOptions>(props.regData.target ? radioButtonOptionsReverseMap(props.regData.target) : props.defaultOption);
    const [customName, setCustomName] = React.useState<string>(props.regData.customName ?? "");
    const [customEmail, setCustomEmail] = React.useState<string>(props.regData.customEmail ?? "");
    const [errorDisplay, setErrorDisplay] = React.useState<string>("DEFAULT");


    /**
     * Handler for when the radio button options are changed
     * @param event Event triggered by onChange
     */
    const handleOptionChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
        const selected = radioButtonOptionsReverseMap(event.target.value);
        setSelectedOption(selected);
    }

    const handleCustomName: React.ChangeEventHandler<HTMLInputElement> = (event) => 
    {
        const input = event.target.value;
        setCustomName(input);
    }

    const handleCustomEmail: React.ChangeEventHandler<HTMLInputElement> = (event) => 
    {
        const input = event.target.value;
        setCustomEmail(input);
    }

    const verifyDataInput = (input: any): [boolean, string] =>
    {
        if (input.target === undefined)
        {
            return [false, "Please select someone to assign this registration to."]
        }
        if (input.target === RadioButtonOptions.custom)
        {
            if (customName === "")
            {
                return [false, "Please enter a name."]
            }
            if (customEmail === "")
            {
                return [false, "Please enter an email."]
            }
        }
        return [true, ""];
    }

    React.useEffect(() => 
    {
        const newData = 
        {
            index: props.regData.index,
            userId: props.regData.userId,
            target: selectedOption,
            customName: customName,
            customEmail: customEmail
        }

        const [isValid, errorMsg] = verifyDataInput(newData);

        setErrorDisplay(errorMsg);

        props.onDataChange(props.regData.index, newData, isValid, isValid ? undefined: errorMsg);
    },[selectedOption, customName, customEmail])


    return(
        <div className='checkoutPageDonationForm'>
            <div>
                <p> Registration #{props.regData.index}:</p>
            </div>
            <div>
                <div className='checkoutPageDonationRadioButtons'>
                    <input
                        type="radio"
                        id='1'
                        name={props.componentName.concat('radio')}
                        value={RadioButtonOptions.loggedInUser}
                        checked={selectedOption === RadioButtonOptions.loggedInUser}
                        disabled={(props.disableInputs ?? false) || !(props.isUserTargetEnabled ?? true)}
                        onChange={handleOptionChange}
                    />
                    <label htmlFor="1">
                        For {props.loggedInUser}
                    </label>
                </div>
                <div className='checkoutPageDonationRadioButtons'>
                    <input
                    type="radio"
                    id='2'
                    name={props.componentName.concat('radio')}
                    value={RadioButtonOptions.custom}
                    checked={selectedOption === RadioButtonOptions.custom}
                    disabled={props.disableInputs ?? false}
                    onChange={handleOptionChange}
                    />
                    <label className='checkoutPageInputs' htmlFor="2" >
                        <span>
                            For someone else:
                        </span>
                        <br></br>
                        <br></br>
                        <label className='checkoutPageInputs' htmlFor="3">First & Last Name:</label>
                        <input
                            className='checkoutPageDonationRadioButtons'
                            id='3'
                            type='text'
                            name={props.componentName.concat('radio').concat('customName')}
                            value={customName}
                            disabled={props.disableInputs ?? false}
                            onChange={handleCustomName}
                            placeholder='First & Last Name'
                        />
                        <br></br>
                        <label className='checkoutPageInputs' htmlFor="4">Email Address:</label>
                        <input
                            className='checkoutPageDonationRadioButtons'
                            id='4'
                            type='text'
                            name={props.componentName.concat('radio').concat('customEmail')}
                            value={customEmail}
                            disabled={props.disableInputs ?? false}
                            onChange={handleCustomEmail}
                            placeholder='Email Address'
                        />
                    </label>
                </div>
            </div>
            <div className='checkoutPageTextError'>
                <span>{errorDisplay}</span>
            </div>
        </div>
    )
}

export default IndividualRegistrationForm